/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplePayload } from '../models/ApplePayload';
import type { ExtractTokenResponse } from '../models/ExtractTokenResponse';
import type { GooglePayload } from '../models/GooglePayload';
import type { RegisterUserRequestDTO } from '../models/RegisterUserRequestDTO';
import type { UserDTO } from '../models/UserDTO';
import type { UserLoginRequestDTO } from '../models/UserLoginRequestDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AuthService {

    /**
     * Registers a new User with Email and Password.
     * @param requestBody Contains all relevant data to create a new user.
     * @returns binary Is returned in success of the registration.
     * @throws ApiError
     */
    public static authRegisterUser(
        requestBody: RegisterUserRequestDTO,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Auth/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Is returned when User already exists with Email and Password login.`,
                401: `Is returned when the Email is already in use with a different login provider (like Google, FB, etc.).`,
            },
        });
    }

    /**
     * Login a user with Email and Password.
     * @param requestBody Contains the login credentials
     * @returns UserDTO Is returned when the user is authenticated successfully and contains a fresh token.
     * @throws ApiError
     */
    public static authLoginUser(
        requestBody: UserLoginRequestDTO,
    ): CancelablePromise<UserDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Auth/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Is returned when the password with the corresponding email are invalid.`,
                404: `Is returned when a user with the given Email address cannot be found.`,
            },
        });
    }

    /**
     * Authenticate a user with googles login credentials fetched in client code.
     * A new user is created when none already exists or an existing user can be merged
     * into google login, when specified in the request.
     * @param requestBody Data fetched from Google OAuth login on client side and optional merge setting.
     * @returns UserDTO Is returned when the user is authenticated from the google login payload.
     * @throws ApiError
     */
    public static authAuthenticateGoogle(
        requestBody: GooglePayload,
    ): CancelablePromise<UserDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Auth/google',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Is returned when no token is given or the token is invalid.`,
                422: `Is returned when the email address is already in use with a different login provider.`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns UserDTO Is returned when the user is authenticated from the apple login payload.
     * @throws ApiError
     */
    public static authAuthenticateApple(
        requestBody: ApplePayload,
    ): CancelablePromise<UserDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Auth/apple',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Is returned when no token is given or the token is invalid.`,
                422: `Is returned when the email address is already in use with a different login provider.`,
            },
        });
    }

    /**
     * @param code
     * @param userId
     * @param appName
     * @param lang
     * @returns void
     * @throws ApiError
     */
    public static authVerifyUser(
        code?: string | null,
        userId?: string,
        appName?: string | null,
        lang: string | null = '',
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Auth/verify',
            query: {
                'code': code,
                'userId': userId,
                'appName': appName,
                'lang': lang,
            },
        });
    }

    /**
     * Extracts session token from the cookie send with the request.
     * If no cookie is present in the request, no content ist returned.
     * @returns ExtractTokenResponse Is returned when the token is successfully extracted from the Request.
     * @throws ApiError
     */
    public static authExtractSessionTokenFromCookie(): CancelablePromise<ExtractTokenResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Auth/cookie',
        });
    }

    /**
     * @returns binary Is returned by default, with the cookie sessionToken removed.
     * @throws ApiError
     */
    public static authDeleteSessionTokenFromCookies(): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Auth/cookie',
            errors: {
                400: `Is returned when request url does not contain klangio.com or klang.io to access domain cookies.`,
            },
        });
    }

}
